export default window.__config__ || {};
